// Definição da interface do produto
export interface Product {
  id: string;
  slug: string;
  displayName: string;
  description: string;
  htmlDescription: string;
  features: string[];
  icon: string;
}

// Definições dos produtos
export const PRODUCTS: Record<string, Product> = {
  ASTRAL_MAP: {
    id: 'astral-map',
    slug: 'astral-map',
    displayName: 'MAPA ASTRAL',
    description: 'Análise completa do mapa astral de nascimento com posições planetárias detalhadas e interpretações.',
    htmlDescription: `
      <h3>MAPA ASTRAL</h3>
      <p>Descubra seu projeto cósmico com nossa análise completa do mapa astral de nascimento. Este relatório detalhado inclui:</p>
      <ul>
        <li>Posições planetárias completas no momento do seu nascimento</li>
        <li>Interpretações detalhadas do seu sol, lua e signo ascendente</li>
        <li>Análise dos aspectos planetários e suas influências</li>
        <li>Insights personalizados sobre sua personalidade e caminho de vida</li>
        <li>Cálculos astrológicos de nível profissional</li>
      </ul>
    `,
    features: [
      'Visualização completa do mapa de nascimento',
      'Posições e aspectos planetários',
      'Divisões das casas e interpretações',
      'Insights astrológicos pessoais'
    ],
    icon: '⭐'
  },
  TIKKUN_MAP: {
    id: 'tikkun-map',
    slug: 'tikkun-map',
    displayName: 'MAPA DA ALMA',
    description: 'Mapa avançado de cura espiritual baseado em princípios cabalísticos e técnicas de correção da alma.',
    htmlDescription: `
      <h3>MAPA DA ALMA</h3>
      <p>Embarque em uma jornada espiritual de correção da alma com nosso Mapa da Alma avançado. Este relatório especializado oferece:</p>
      <ul>
        <li>Análise cabalística da jornada da sua alma</li>
        <li>Identificação de lições e desafios espirituais</li>
        <li>Orientação para crescimento pessoal e transformação</li>
        <li>Recomendações de cura baseadas na sabedoria antiga</li>
        <li>Integração de insights astrológicos e espirituais</li>
      </ul>
    `,
    features: [
      'Visualização completa do mapa astral',
      'Interpretação do Nodo Norte',
      'Análise da posição do Sol',
      'Insights sobre a posição de Saturno',
      'Detalhes da posição de Lilith',
      'Orientação espiritual aprimorada'
    ],
    icon: '🌟'
  }
} as const;

// Definições de tipos para tipagem forte
type ProductKeys = keyof typeof PRODUCTS;
export type ProductId = typeof PRODUCTS[ProductKeys]['id'];
export type ProductSlug = typeof PRODUCTS[ProductKeys]['slug'];

// Funções utilitárias
export const isValidProductId = (productId: string) => {
  const product = Object.values(PRODUCTS).find(p => p.id === productId);
  return product !== undefined;
};

export const isValidProductSlug = (slug: string) => {
  const product = Object.values(PRODUCTS).find(p => p.slug === slug);
  return product !== undefined;
};

export const getProductBySlug = (slug: string): Product | null => {
  const product = Object.values(PRODUCTS).find(p => p.slug === slug);
  return product || null;
};

export const getProductById = (id: ProductId): Product => {
  const product = Object.values(PRODUCTS).find(p => p.id === id);
  if (!product) {
    throw new Error(`Produto com ID ${id} não encontrado`);
  }
  return product;
};

// Utilitários de caminho de armazenamento
export const getStoragePath = (purchaseId: string, productId: ProductId): string => {
  const product = getProductById(productId);
  return `astral-maps/${purchaseId}/${product?.slug}-report.pdf`;
};

// Utilitários de URL
export const getProductUrl = (purchaseId: string, productId: ProductId): string => {
  const product = getProductById(productId);
  return `/astral-map?purchaseId=${purchaseId}&productId=${product?.slug}`;
}; 